import { effect, inject, Service, signal } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

type DescriptionMode = { type: 'translation'; key: string } | { type: 'static'; text: string };

@Service()
export class AppMeta {
  private readonly meta = inject(Meta);
  private readonly translateService = inject(TranslateService);

  private readonly defaultDescription =
    'HMS-kort er et ID-krav i enkelte bransjer. Den offisielle prisen per kort er 139,10 + mva. Her bestiller du HMS-kort direkte fra Arbeidstilsynet.';
  private readonly config = signal<DescriptionMode>({
    type: 'static',
    text: this.defaultDescription
  });

  constructor() {
    effect(() => {
      const config = this.config();
      const content =
        config.type === 'translation'
          ? this.translateService.instant(config.key)
          : this.normalize(config.text) || this.defaultDescription;

      this.meta.updateTag({
        name: 'description',
        content: content
      });
    });
  }

  setTranslationDescription(key: string): void {
    this.config.set({ type: 'translation', key });
  }

  setStaticDescription(text: string): void {
    this.config.set({ type: 'static', text });
  }

  private normalize(content: string): string {
    const withoutTags = content.replace(/<[^>]*>|#/g, ' ');
    const collapsed = withoutTags.replace(/\s+/g, ' ').trim();
    const maxLength = 160; // recommended max length for meta description

    if (collapsed.length > maxLength) {
      return `${collapsed.slice(0, maxLength - 3).trimEnd()}...`;
    }

    return collapsed;
  }
}
